// extracted by mini-css-extract-plugin
module.exports = {"skills":"Skills_skills__2B-hV","heading":"Skills_heading__2fVjW","skillsSection":"Skills_skillsSection__39__g","allSkills":"Skills_allSkills__2npYZ"};